/**
 * Environment-aware logger utility.
 * Suppresses debug/log output in production while preserving warn/error.
 */

const isDev = process.env.NODE_ENV === 'development';

const logger = {
  log: isDev ? console.log.bind(console) : () => {},
  debug: isDev ? console.debug.bind(console) : () => {},
  info: isDev ? console.info.bind(console) : () => {},
  warn: console.warn.bind(console),
  error: console.error.bind(console),
};

export default logger;
